<template>
	<div class="flex flex-1 items-center">
		<div class="flex">
			<app-icon class="cursor-pointer" icon="left" @click="leftScroll" />
		</div>
		<div class="flex flex-1 overflow-x-hidden" ref="scrollableElement">
			<slot />
		</div>
		<div class="flex">
			<app-icon class="cursor-pointer" icon="right" @click="rightScroll" />
		</div>
	</div>
</template>

<script>
	import AppIcon from '@/components/app/AppIcon';

	const itemWidth = 125;

	export default {
		name: 'AppScrollable',
		components: { AppIcon },
		methods: {
			leftScroll() {
				const el = this.$refs.scrollableElement;
				el.scrollLeft = Math.max(el.scrollLeft - itemWidth, 0);
			},
			rightScroll() {
				const el = this.$refs.scrollableElement;
				el.scrollLeft += itemWidth;
			},
		},
	};
</script>
